module.exports = __webpack_public_path__ + "img/Marca15.48fe07f5.jpg";